export default __webpack_public_path__ + "static/media/avatar-s-11.e7126e47.png";